// extracted by mini-css-extract-plugin
export default {"main":"Home_main__kznKp","main_mouse_canvas":"Home_main_mouse_canvas__H7NDx"};